/**
 * @description: 套餐名称
 * @author: ct
 * @update: cyp
 * @update: hwx
 * @update: lyr
 */
<template>
	<div>
		<div class="packageNameMain" v-show="showMain">
			<button class="btn btn-flat btn-large btn-orange" v-on:click="enterAddPackage" v-if="list_menu_add">设置开房套餐名称</button>
			<div class="row ct-row">
				<label class="ct-label">门店:</label>
				<div class="col-md-2 ct-col">
					<select class="form-control" ref="shop" data-placeholder="请选择门店"></select>
				</div>
				<label class="ct-label">套餐类型:</label>
				<div class="col-lg-2 ct-col">
					<select class="select2 ct-select" data-placeholder="请选择套餐" ref="package_type">
						<option value="0">全部</option>
						<option value="1">时间套餐</option>
						<option value="2">酒水套餐</option>
						<option value="3">最低消费套餐</option>
						<option value="4">团购套餐</option>
					</select>
				</div>
				<label class="ct-label">套餐名称:</label>
				<div class="col-sm-4 col-lg-2 ct-col">
					<div class="input-group">
						<input type="text" class="form-control" id="package_name" v-model="package_name" placeholder="请输入套餐名称">
					</div>
				</div>
				<div class="pull-right">
					<button type="button" class="btn btn-flat btn-small btn-orange" v-on:click="searchMainTable">查询</button>
				</div>
			</div>
			<div class="table-responsive">
				<table class="table table-striped table-bordered table-hover" data-pagination="true" ref="packageName_table"></table>
			</div>
		</div>
		<div class="packageNameDetail" v-show="!showMain">
			<p class="ct-topTitle">{{addOrEdit}}开房套餐</p>
			<div class="row handle-package">
				<div class="row">
					<label class="col-xs-2 ct-label">套餐图片</label>
					<div class="col-xs-10 ct-col">
						<div class="ct-upload">
							<img class="uploadimg defaultimage" :src="editNameParams.img_url" @click="clickUpload" @load="successLoadImg" @error="errorLoadImg">
							<input id="uploadPackage" class="uploadinput" name="file" type="file" style="display: none" @change="changeUpload($event)" ref="uploadPackage">
						</div>
					</div>
				</div>
				<div class="row">
					<label class="col-xs-2 ct-label">适用门店</label>
					<div class="col-md-10 ct-col">
						<select class="form-control" ref="package_name_shop" data-placeholder="请选择门店"></select>
					</div>
				</div>
				<div class="row">
					<label class="col-xs-2 ct-label">套餐类型</label>
					<div class="col-xs-10 ct-col">
						<div class="ChooseType form-control" v-on:click="choosePackageType" ref="PackageTypeRef">{{editNameParams.type_name}}</div>
					</div>
				</div>
				<div class="row" v-show="editNameParams.type=='3'">
					<label class="col-xs-2 ct-label">低消方式</label>
					<div class="col-xs-10 ct-col">
						<select class="select2 ct-select" data-placeholder="请选择低消方式" ref="package_minimum_type">
							<option value="1">现付方式</option>
							<option value="2">后结方式</option>
						</select>
						<el-popover
							placement="right"
							trigger="hover"
							title="说明：">
							<p>现付方式：可作为请客套餐，先付低消金额，该金额可用于购买房费与商品</p>
							<p>后结方式：低消套餐开房后结，消费不满低消金额，结账时收取低消金额</p>
							<i class="el-icon-question my-el-hint" slot="reference"></i>
						</el-popover>
					</div>
				</div>
				<div class="row">
					<label class="col-xs-2 ct-label">套餐名称</label>
					<div class="col-xs-10 ct-col">
						<input type="text" id="package_detail_name" class="form-control" placeholder="请输入套餐名称" v-model="editNameParams.name" />
					</div>
				</div>

				<div class="row">
					<label class="col-xs-2 ct-label">时长(分钟)</label>
					<div class="col-xs-8 ct-col">
						<input type="text" id="package_detail_time" class="form-control" placeholder="请输入时长" v-model="editNameParams.time" />
					</div>
					<label class="col-xs-2 ct-label" style="padding: 0;">{{cmpTime}}</label>
				</div>

			</div>
			<p class="ct-topTitle" v-show="isNeed">添加开房套餐商品 <button type="button" class="btn btn-flat btn-middle btn-orange pull-right" @click="chooseGoods">增加商品</button></p>
			<div class="table-responsive scroll-table" v-show="isNeed">
				<table class="table table-striped table-bordered table-hover" ref="packageDetail_table"></table>
			</div>
			<!--选择套餐类型-->
			<div id="chooseType_popup">
				<div class="chooseType-popup-wrap">
					<ul class="chooseType-content" ref="chooseType-content">
						<li class="clearfix">
							<input type="radio" name="a" v-model="editNameParams.type" value="1" />
							<div class="choosetype-txt">
								<p>时间套餐</p>
								<p class="orange-text turnRed">只有时间费开房套餐</p>
							</div>
						</li>
						<li class="clearfix">
							<input type="radio" name="a" v-model="editNameParams.type" value="2" />
							<div class="choosetype-txt">
								<p>酒水套餐</p>
								<p class="orange-text turnRed">包含时间与商品费开房套餐，商品必选</p>
							</div>
						</li>
						<li class="clearfix">
							<input type="radio" name="a" v-model="editNameParams.type" value="3" />
							<div class="choosetype-txt">
								<p>最低消费套餐</p>
								<p class="orange-text turnRed">包厢最低消金额</p>
							</div>
						</li>
						<li class="clearfix">
							<input type="radio" name="a" v-model="editNameParams.type" value="4" />
							<div class="choosetype-txt">
								<p>团购套餐</p>
								<p class="orange-text turnRed">时间+商品（非必选），与团购平台设置内容一致，在本地开房时只需输入团购券号</p>
							</div>
						</li>
					</ul>
					<div class="chooseType-btn">
						<button type="button" class="btn btn-middle btn-flat btn-border-gray" style="margin-left: 0;" v-on:click="closelayer">取消</button>
						<button type="button" class="btn btn-middle bg-orange btn-flat" style="margin-left:50px" v-on:click="sureChooseType">确定</button>
					</div>

				</div>
			</div>
			<!-- 增加商品弹窗 -->
			<div id="addGoods_popup">
				<div class="row">
					<div class="col-md-4 ct-col">
						<select class="select2 ct-select" style="width: 100%;" id="addGoods_select" data-placeholder="请选择类型" ref="addGoods_select">
						</select>
					</div>
					<div class="col-md-6" style="padding-right: 0;">
						<input class="form-control" placeholder="请输入商品名称" style="border: 1px solid #009af0;" v-model="searchGoodsName">
					</div>
					<div class="col-md-2" style="padding-left: 0;">
						<button type="button" class="btn bg-orange btn-flat btn-wide" @click="searchGoods">查询</button>
					</div>
				</div>
				<div class="table-responsive">
					<table class="table table-striped table-bordered table-hover" data-pagination="true" ref="addGoods_table"></table>
				</div>
			</div>
			<!-- 填写数量 -->
			<div class="good-num-pop" ref="good_num_pop">
				<div class="row">
					<label class="col-md-3">名称：</label>
					<div class="col-md-9">
						<span>{{cur_good_name}}</span>
					</div>
				</div>
				<div class="row">
					<label class="col-md-3">数量：</label>
					<div class="col-md-9">
						<input class="form-control" placeholder="请输入数量" v-model="cur_good_num">
					</div>
				</div>
			</div>
			<div class="package-name-bottom">
				<button type="button" class="btn btn-middle btn-flat btn-border-gray" style="margin-left: 0;" id="" v-on:click="enterMainPackage">返回</button>
				<button type="button" class="btn btn-middle bg-orange btn-flat" style="margin-left:50px" id="savePackage" v-on:click="set_package_name">确定</button>
			</div>

		</div>
	</div>

</template>

<script>
	import Vue from 'vue';
	export default {
		data() {
			return {
				list_menu_add: false,
            	list_menu_op: [],
				employeeinput: '请输入姓名',
				userinfo: {},
				packageName_table: [],
				packageDetail_table: [],
				addGoods_table: [],
				operateType: "edit",
				showMain: true,
				Base64Image: "",
				ChooseType: "请选择套餐类型",
				search_packageName: "",
				package_name: "",
				add_shop_data: [],
				addOrEdit:"添加",
				editNameParams: {
					type_name: "请选择套餐类型",
					img_url: "",
					time: "",
					type: "",
					package_minimum_type: "",
				},
				isNeed: false,
				searchGoodsName: "",
				cur_good_name: '',
				cur_good_num: '',
				goodsType_list: [],
				goodsType_sign: '',
				goodsType_sign_id: '',
			}
		},
		computed: {
			cmpTime() {
				let _this = this;
				let package_time = "";
				if(_this.editNameParams.time != "" && !isNaN(_this.editNameParams.time)) {
					package_time = "(" + parseInt(_this.editNameParams.time / 60) + "小时" + (_this.editNameParams.time % 60) + "分钟)";
				} else {
					package_time = ""
				}
				return package_time
			}
		},
		mounted: function() {
			this.getMenuOp();
			this.$nextTick(function() {
				let _this = this;
				$(_this.$refs.package_type).select2({
					language: "zh-CN",
					allowClear: true,
					minimumResultsForSearch: -1,
					width: '100%'
				});
				$(_this.$refs.package_minimum_type).select2({
					language: "zh-CN",
					allowClear: true,
					minimumResultsForSearch: -1,
					width: '100%'
				});
				// _this.initMainTable();
				_this.getShopData();
				_this.getCusPakage();
			});
		},
		methods: {
			// 获取权限
			getMenuOp() {
				let _this = this,
					menu = [];
				if(!$.isEmptyObject(this.$store.state.menunew)) {
					menu = JSON.parse(this.$store.state.menunew);
					$.each(menu, function(k, v) {
						if(v.id == '542') {
							menu = v.submenu;
							$.each(menu, function(m, n) {
								if(n.id == '551') {
									menu = n.submenu;
								}
							});
						}
					});

					_this.list_menu_op = [];
					$.each(menu, function(x, y) {
						if(y.id == '918') {
							_this.list_menu_add = true;
							_this.list_menu_op.push({cls: 'text-blue copy-add', name: '复制新增'});
						}
						if(y.id == '919') {
							_this.list_menu_op.push({cls: 'text-blue gotopackageNameDetail', name: '修改'});
						}
						if(y.id == '920') {
							_this.list_menu_op.push({cls: 'text-blue del', name: '删除'});
						}
					});
				}
			},
			// 进入首页的清空首页的选择项
			enterMainPackage: function() {
				let _this = this;
				_this.showMain = true;
				
				if(_this.operateType == "add"){
					$(_this.$refs.package_type).val("").trigger("change");
					_this.package_name = "";
					$(_this.$refs.packageName_table).bootstrapTable('refreshOptions',{pageNumber:1});
				}else{
					$(_this.$refs.packageName_table).bootstrapTable('refresh');
				}
			},
			// 进入设置页的清空设置页的选择项
			enterAddPackage: function() {
				let _this = this;
				_this.operateType = "add";
				_this.addOrEdit = "添加";
				_this.showMain = false;
				_this.isNeed = false;
				
				$(_this.$refs.PackageTypeRef).removeClass("grey-bg");
				$(_this.$refs.package_name_shop).removeClass("grey-bg");
				$(_this.$refs.package_name_shop).removeAttr("disabled");
				_this.editNameParams.type_name = "请选择套餐类型";
				_this.packageDetail_table = [];
				_this.initDetailTable();
				_this.editNameParams.type = "";
				_this.editNameParams.time = "";
				_this.editNameParams.name = "";
				_this.editNameParams.package_minimum_type = "";
				$(_this.$refs.package_name_shop).val("").trigger("change");
				$(_this.$refs.package_minimum_type).val("").trigger("change");
				for(let i = 0; i < $(".chooseType-popup-wrap input").length; i++) {
					$(".chooseType-popup-wrap input").eq(i).prop("checked", false);
				}
				_this.editNameParams.img_url = "";
			},
			// 进入修改页面
			enterEditPackage: function() {
				let _this = this;
				_this.operateType = "edit";
				_this.addOrEdit = "修改";
				_this.showMain = false;
				_this.editNameParams.img_url = "";
				_this.packageDetail_table = [];
				_this.editNameParams.time = "";
				_this.editNameParams.name = "";
				_this.editNameParams.package_minimum_type = "";
				$(_this.$refs.package_name_shop).val("").trigger("change");
				$(_this.$refs.package_minimum_type).val("").trigger("change");
				for(let i = 0; i < $(".chooseType-popup-wrap input").length; i++) {
					$(".chooseType-popup-wrap input").eq(i).prop("checked", false);
				}
				$(_this.$refs.PackageTypeRef).addClass("grey-bg");
				$(_this.$refs.package_name_shop).addClass("grey-bg");
				$(_this.$refs.package_name_shop).attr("disabled", "disabled");
				_this.editNameParams.img_url = "";
			},
			// 获取门店数据
			getShopData() {
				let _this = this;

				let shopDatas = [];
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: {
						json: datas2
					},
					success: function(data) {
						if(data.response.result_code == "true") {
							// _this.initShopData = data.response.result;
							// _this.initShop();

							$.each(data['response']['result'], function(k, v) {
								shopDatas.push({ id: v.id, text: v.name });
							});
							$(_this.$refs.shop).select2({
								data: shopDatas,
								allowClear: true,
								minimumResultsForSearch: -1,
								language: "zh-CN",
								width: '100%'
							});
							$(_this.$refs.shop).val(data.response.result[1].id).trigger('change');
							_this.initMainTable();

							_this.add_shop_data = shopDatas;
							_this.add_shop_data.splice(0, 1);
							$(_this.$refs.package_name_shop).select2({
								data: _this.add_shop_data,
								allowClear: true,
								minimumResultsForSearch: -1,
								language: "zh-CN",
								width: '100%'
							}).on("select2:select", function(e) {
								$(_this.$refs.packageDetail_table).bootstrapTable("destroy");
								_this.packageDetail_table = [];
							});
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.msg("网络错误");
					}
				});
			},
			closelayer: function() {
				layer.closeAll();
			},
			sureChooseType() {
				let _this = this;
				
				if(_this.editNameParams.type == '1') {
					_this.editNameParams.type_name = '时间套餐';
				} else if(_this.editNameParams.type == '2') {
					_this.editNameParams.type_name = '酒水套餐';
				} else if(_this.editNameParams.type == '3') {
					_this.editNameParams.type_name = '最低消费套餐';
				} else if(_this.editNameParams.type == '4') {
					_this.editNameParams.type_name = '团购套餐';
				}
				// _this.editNameParams.type = "";
				// for(let i = 0; i < $(".chooseType-content input").length; i++) {
				// 	if($(".chooseType-content input").eq(i).prop("checked") == true) {
				// 		_this.editNameParams.type = i + 1;
				// 		_this.editNameParams.type_name = $(".chooseType-content input").eq(i).val();
				// 	}
				// }
				if(_this.editNameParams.type == "2" || _this.editNameParams.type == "4") {
					_this.isNeed = true;
				} else {
					_this.isNeed = false;
					_this.packageDetail_table = [];
					_this.initDetailTable();
				}
				layer.closeAll();
			},
			clickUpload: function() {
				$(".handle-package #uploadPackage").click();
			},
			// 选中图片
			changeUpload: function(e) {
				var _this = this;
				var layIndex = layer.load(0, {
					shade: [0.1, '#ececec']
				});
				var file = e.target.files[0];
				// 清除file
				e.target.value = '';
				if(typeof(file) == 'undefined') {
					layer.msg('图片上传失败');
					layer.close(layIndex);
					return false;
				}
				// 压缩图片
				var reader = new FileReader(),
					img = new Image();
				var canvas = document.createElement('canvas');
				var context = canvas.getContext('2d');
				reader.readAsDataURL(file);
				reader.onload = function(e) {
					img.src = e.target.result;
				};
				img.onload = function () {
					// 图片原始尺寸
					var originWidth = this.width;
					var originHeight = this.height;
					// 最大尺寸限制
					var maxWidth = 660, maxHeight = 240;
					// 目标尺寸
					var targetWidth = originWidth, targetHeight = originHeight;
					// 图片尺寸超过限制
					if (originWidth > maxWidth || originHeight > maxHeight) {
						if (originWidth / originHeight > maxWidth / maxHeight) {
							// 更宽，按照宽度限定尺寸
							targetWidth = maxWidth;
							targetHeight = Math.round(maxWidth * (originHeight / originWidth));
						} else {
							targetHeight = maxHeight;
							targetWidth = Math.round(maxHeight * (originWidth / originHeight));
						}
					}
					// canvas对图片进行缩放
					canvas.width = targetWidth;
					canvas.height = targetHeight;
					// 清除画布
					context.clearRect(0, 0, targetWidth, targetHeight);
					// 图片压缩
					context.drawImage(img, 0, 0, targetWidth, targetHeight);
					// canvas转为blob并上传
					var dataurl = canvas.toDataURL('image/png');
					var blob = dataURLtoBlob(dataurl);
					// 创建forme
					var form = new FormData();
					form.append('img', blob, "image.png");
					form.append("upload_path", "ktv_test");
					// 上传
					$.ajax({
						type: "post",
						dataType: "json",
						processData: false,
						contentType: false,
						url: Vue.ctUrl + "Upload/api_uploadPic",
						crossDomain: true,
						xhrFields: {
							withCredentials: true
						},
						data: form,
						success: function(data) {
							if(data.response.result_code == "true") {
								_this.editNameParams.img_url = data.response.resault.img_url;
							} else {
								Vue.timeoutfun(data.response.result_status, _this);
								layer.msg("图片上传失败");
							}
							layer.close(layIndex);
						},
						error: function(err) {
							layer.msg("网络原因");
							layer.close(layIndex);
						}
					});
				}
			},
			successLoadImg: function(event) {
				if(event.target.complete == true) {
					event.target.classList.remove("defaultimage");
				}
			},
			errorLoadImg: function(event) {
				event.target.classList.add("defaultimage");
			},
			choosePackageType: function() {
				let _this = this;
				if(_this.operateType == "edit") {

				} else {
					layer.open({
						type: 1,
						title: '套餐类型',
						area: ['450px', '450px'], // 宽高
						content: $('#chooseType_popup')
					});
				}
			},
			chooseGoods: function() {
				let _this = this;

				$(_this.$refs.addGoods_select).val('').trigger('change');
				_this.goodsType_sign = '';
				_this.initGoodsTable();
				layer.open({
					type: 1,
					title: '增加商品',
					btn: [],
					area: ['720px', ''], // 宽高
					content: $('#addGoods_popup'),
					offset: '100px'
				});
			},
			searchMainTable: function() {
				let _this = this;
				$(_this.$refs.packageName_table).bootstrapTable('refreshOptions', {pageNumber: 1});
			},

			initMainTable: function() {
				let _this = this;
				let actionEvents = {
					'click .gotopackageNameDetail': function(e, value, row, index) {
						_this.enterEditPackage();
						_this.editNameParams.id = row.id;
						_this.getPackageDetail(_this.editNameParams.id, '');
					},
					'click .del': function(e, value, row, index) {
						layer.confirm('删除后“'+ row.name +'”的开房套餐将失效，确定删除？', {
							btn: ['确定', '取消'] //按钮
						}, function() {
							_this.delPacName(row.id);
						});
					},
					'click .copy-add': function(e, value, row, index) {
						_this.getPackageDetail(row.id, 'copy_add');
					}
				};
				$(_this.$refs.packageName_table).bootstrapTable({
					pageNumber: 1,
					pageSize: 10,
					pageList: [],
					ajax: function(params) {
						_this.getPackageNameList(params, _this);
					},
					sidePagination: "server",
					pagination: true,
					columns: [{
						field: "img_url",
						title: "图片",
						width: "15%",
						formatter: function(value) {
							return '<div class="ct-imgwrap"><img src=' + value + '></div>';
						}
					}, {
						field: "shop_name",
						title: "门店",
						width: "15%"
					}, {
						field: "type_name",
						title: "套餐类型",
						width: "15%"
					}, {
						field: "name",
						title: "套餐名称",
						width: "20%"
					}, {
						field: "time",
						title: "时长/分钟",
						width: "15%"
					}, {
						field: "operation",
						title: "操作",
						width: "20%",
						events: actionEvents,
						formatter: function(value) {
							let op_html = '';
							$.each(_this.list_menu_op, function(k, v) {
								op_html += '<span class="'+ v.cls +'">'+ v.name +'</span>&nbsp;&nbsp;';
							});
							return op_html;
						}

					}]
				})
			},
			getPackageNameList: function(params, _this) {
				let pageNumber = 1;
				if(params.data.offset != 0) {
					pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
				}
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"shop_id": $(_this.$refs.shop).val(),
							"type": $(_this.$refs.package_type).val(),
							"name": _this.package_name,
							"page": pageNumber,
							"page_size": "10",
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "roomPackage/searchRoomPackage",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: {
						json: datas2
					},
					success: function(data) {
						if(data.response.result_code == "true") {
							params.success({
								total: data.response.result.total,
								rows: data.response.result.rows
							});

						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data.response.error_msg);
							params.success({
								total: 0,
								rows: []
							});
						}
					},
					error: function(err) {
						layer.msg("网络错误");
					}
				});

			},

			// 详情页
			initDetailTable: function() {
				let _this = this;
				var actionEvents = {
					'click .deletepackageGoods': function(e, value, row, index) {
						layer.confirm("确定删除该商品吗？", {
							btn: ['确定', '取消'], //按钮
						}, function() {
							let depositeData = [];
							for(let i = 0; i < _this.packageDetail_table.length; i++) {
								if(_this.packageDetail_table[i].merchant_goods_id != row.merchant_goods_id) {
									depositeData.push(_this.packageDetail_table[i]);
								}
							}
							_this.packageDetail_table = depositeData;
							$(_this.$refs.packageDetail_table).bootstrapTable("destroy");
							_this.initDetailTable();
							layer.closeAll();
						});

					},
					'keypress .quantity': function(e, value, row, index) {
						if(event.keyCode == "13") {
							$(this).blur();
						}
					},
					'blur .quantity': function(e, value, row, index) {
						if(isNaN($(this).val())) {
							layer.msg("请输入数字");
							$(this).val(value);
							return;
						} else if($(this).val() < 1) {
							layer.msg("数量不小于1");
							$(this).val(value);
							return;
						} else if($(this).val().indexOf('.') != '-1') {
							layer.msg("请输入整数");
							$(this).val(value);
							return;
						}
					
						var _thiss=$(this);
						for(let i = 0; i < _this.packageDetail_table.length; i++) {
							if(_this.packageDetail_table[i].merchant_goods_id == row.merchant_goods_id) {
								var quantity=_thiss.val();
								var cost_price=_this.packageDetail_table[i].cost_price;
								_this.packageDetail_table[i].quantity =quantity ;
								var allprice=Vue.accMul(quantity,cost_price);
								_this.packageDetail_table[i].allprice=allprice;
							}
						}
						$(_this.$refs.packageDetail_table).bootstrapTable('load',_this.packageDetail_table);
					},
				};
				$(_this.$refs.packageDetail_table).bootstrapTable("destroy");
				$(_this.$refs.packageDetail_table).bootstrapTable({
					pageNumber: 1,
					pageSize: 10,
					pageList: [],
					columns: [{
						field: "goods_img",
						title: "图片",
						width: "15%",
						formatter: function(value) {
							return '<div class="ct-imgwrap1"><img src=' + value + '></div>';
						}
					}, {
						field: "goods_name",
						title: "商品名称",
						width: "15%"
					}, {
						field: "goods_type_name",
						title: "商品类型",
						width: "15%"
					}, {
						field: "goods_unit_name",
						title: "商品单位",
						width: "15%"
					}, {
						field: "quantity",
						title: "商品数量",
						width: "15%",
						events: actionEvents,
						formatter: function(value) {
							return '<input class="quantity" value="' + value + '">';
						}
					}, {
						field: "allprice",
						title: "原价金额",
						width: "10%"
					}, {
						field: "operation",
						title: "操作",
						width: "15%",
						events: actionEvents,
						formatter: function(value) {
							return '<div class="orange-text"><a class="deletepackageGoods">删除</a></div>';
						}

					}],
					data: _this.packageDetail_table
				})
			},
			set_package_name() {
				let _this = this;
				if(_this.editNameParams.type == 2 && _this.packageDetail_table == "") {
					layer.msg("酒水套餐包含时间与商品费开房套餐，商品必选");
					return;
				}

				if(this.operateType == "edit") {
					_this.edit_package_name();
				} else {
					if(_this.editNameParams.type != "") {
						if(_this.editNameParams.name != "") {
							if(_this.editNameParams.time != "") {
								_this.add_package_name();
							} else {
								layer.msg("请输入时长(分钟)");
							}
						} else {
							layer.msg("请填写套餐名称");
						}
					} else {
						layer.msg("请选择套餐类型");
					}
				}
			},
			// 添加套餐
			add_package_name() {
				let _this = this;

				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"shop_id": $(_this.$refs.package_name_shop).val(),
							"name": _this.editNameParams.name,
							"type": _this.editNameParams.type,
							"time": _this.editNameParams.time,
							"img_url": _this.editNameParams.img_url,
							"goods": _this.packageDetail_table,
							"package_minimum_type": $(_this.$refs.package_minimum_type).val(),
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "roomPackage/addRoomPackage",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: {
						json: datas2
					},
					success: function(data) {
						if(data.response.result_code == "true") {
							_this.showMain = 1;
							layer.msg("添加成功！");
							$(_this.$refs.packageName_table).bootstrapTable('refreshOptions',{pageNumber:1});
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.msg("网络错误");
					}
				});
			},
			// 修改套餐
			edit_package_name() {
				let _this = this;
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"id": _this.editNameParams.id,
							"name": _this.editNameParams.name,
							"goods": _this.packageDetail_table,
							"img_url": _this.editNameParams.img_url,
							"time": _this.editNameParams.time,
							"package_minimum_type": $(_this.$refs.package_minimum_type).val(),
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "roomPackage/updateRoomPackage",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: {
						json: datas2
					},
					success: function(data) {
						if(data.response.result_code == "true") {
							layer.msg("修改成功");
							_this.enterMainPackage();
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.msg("网络错误");
					}
				});
			},
			getPackageDetail(id, type) {
				let _this = this;
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"id": id,
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "roomPackage/getRoomPackageDetail",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: {
						json: datas2
					},
					success: function(data) {
						if(data.response.result_code == "true") {
							if(type == 'copy_add') {
								_this.operateType = "add";
								_this.addOrEdit = "添加";
								_this.showMain = false;
								$(_this.$refs.PackageTypeRef).removeClass("grey-bg");
								$(_this.$refs.package_name_shop).removeClass("grey-bg");
								$(_this.$refs.package_name_shop).removeAttr("disabled");

								_this.editNameParams.img_url = data.response.result.data.img_url;
								$(_this.$refs.package_name_shop).val(data.response.result.data.shop_id).trigger('change');
								$(_this.$refs.package_minimum_type).val(data.response.result.data.package_minimum_type).trigger('change');
								_this.editNameParams.type = data.response.result.data.type;
								_this.editNameParams.type_name = data.response.result.data.type_name;
								if(_this.editNameParams.type == "2" || _this.editNameParams.type == "4") {
									_this.isNeed = true;
								} else {
									_this.isNeed = false;
								}
								_this.editNameParams.name = data.response.result.data.name;
								_this.editNameParams.time = data.response.result.data.time;
								_this.editNameParams.package_minimum_type = data.response.result.data.package_minimum_type; 
								// _this.packageDetail_table = [];
								_this.packageDetail_table = data.response.result.data.goods;
								$.each(_this.packageDetail_table, function(s, k) {
									let allprice = Vue.accMul(k.quantity,k.cost_price);
									k['allprice'] = allprice;
								});
								_this.initDetailTable();

								return;
							}

							_this.editNameParams = data.response.result.data;
							_this.packageDetail_table = data.response.result.data.goods;
							$.each(_this.packageDetail_table, function(s, k) {
								var allprice=Vue.accMul(k.quantity,k.cost_price);
								k['allprice']=allprice;
							});
							$(_this.$refs.package_name_shop).val(data.response.result.data.shop_id).trigger('change');
							$(_this.$refs.package_minimum_type).val(data.response.result.data.package_minimum_type).trigger('change');
							_this.editNameParams.img_url = data.response.result.data.img_url;
							_this.initDetailTable();
							_this.editNameParams.type = data.response.result.data.type;
							if(_this.editNameParams.type == "2" || _this.editNameParams.type == "4") {
								_this.isNeed = true;
							} else {
								_this.isNeed = false;
							}
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.msg("网络错误");
					}
				});
			},
			// 删除
			delPacName: function(id) {
				let _this = this;
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"id": id,
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "roomPackage/delRoomPackage",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: {
						json: datas2
					},
					success: function(data) {
						if(data.response.result_code == "true") {
							layer.msg("删除成功！");
							$(_this.$refs.packageName_table).bootstrapTable("destroy");
							_this.initMainTable();
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.msg("网络错误");
					}
				});
			},
			// 查询商品、商品套餐
			searchGoods: function() {
				if(this.goodsType_sign == '-2') {
					this.initGoodsPackage();
				} else {
					this.initGoodsTable();
				}
			},
			initGoodsTable: function() {
				let _this = this;
				$(_this.$refs.addGoods_table).bootstrapTable("destroy");
				$(_this.$refs.addGoods_table).bootstrapTable({
					pageNumber: 1,
					pageSize: 5,
					pageList: [],
					ajax: function(params) {
						_this.getGoodsList(params, _this);
					},
					sidePagination: "server",
					pagination: true,
					columns: [{
						field: "goods_name",
						title: "商品名称",
						width: "25%",
					}, {
						field: "goods_type_name",
						title: "类型",
						width: "25%"
					}, {
						field: "goods_unit_name",
						title: "单位",
						width: "15%"
					}, {
						width: "10%",
						field: "quantity",
						title: "数量",
						events: {
							'blur .quantity': function(e, value, row, index) {
								if(isNaN($(this).val())) {
									layer.msg("请输入数字");
									$(this).val(value);
									return;
								} else if($(this).val() < 1) {
									layer.msg("数量不小于1");
									$(this).val(value);
									return;
								} else if($(this).val().indexOf('.') != '-1') {
									layer.msg("请输入整数");
									$(this).val(value);
									return;
								}
								row.quantity = $(this).val()
							},
							'click .quantity': function(e, value, row, index) {
								e.stopPropagation()
							}
						},
						formatter: function(value, row) {
							return '<input class="quantity" value="' + 1 + '">';
						}
					}, {
						field: "op",
						title: "操作",
						width: "25%",
						events: {
							'click .add': function(e, value, row, index) {
								for(let i = 0; i < _this.packageDetail_table.length; i++) {
									if(_this.packageDetail_table[i].merchant_goods_id == row.id) {
										layer.msg("商品已存在");
										return false;
									}
								}
								_this.packageDetail_table.push({ merchant_goods_id: row.id, quantity: row.quantity || 1, goods_name: row.goods_name, goods_type_name: row.goods_type_name, goods_unit_name: row.goods_unit_name,cost_price: row.cost_price, goods_img: row.good_img ,allprice:row.cost_price});
								layer.msg("成功添加商品");
								_this.initDetailTable();
							}
						},
						formatter: function(value, row, index) {
							return '<span class="text-blue add">添加</span>';
						}
					}]
				})
			},
			getGoodsList: function(params, _this) {
				let pageNumber = 1;
				if(params.data.offset != 0) {
					pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
				}
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"shop_id": $(_this.$refs.package_name_shop).val(),
							"goods_type": $(_this.$refs.addGoods_select).val()||"",
							"goods_name": _this.searchGoodsName,
							"recommend": "",
							// "is_sell": "1",
							"page": pageNumber,
							"page_size": 5,
							"status": '1'
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "merchantGoods/searchMerchantGoodsList",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: {
						json: datas2
					},
					success: function(data) {
						if(data.response.result_code == "true") {
							params.success({
								total: data.response.result.data.total,
								rows: data.response.result.data.rows
							});
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data.response.error_msg);
							params.success({
								total: 0,
								rows: []
							});
						}
					},
					error: function(err) {
						layer.msg("网络错误");
					}
				});
			},
			initGoodsPackage: function() {
				let _this = this;
				$(_this.$refs.addGoods_table).bootstrapTable("destroy");
				$(_this.$refs.addGoods_table).bootstrapTable({
					pageNumber: 1,
					pageSize: 5,
					pageList: [],
					ajax: function(params) {
						_this.getGoodsPackage(params, _this);
					},
					sidePagination: "server",
					pagination: true,
					columns: [{
						field: "name",
						title: "商品名称",
						width: "25%",
					}, {
						field: "goods_type_name",
						title: "类型",
						width: "25%",
						formatter: function(value, row, index) {
							return '商品套餐'
						}
					}, {
						field: "package_unit_name",
						title: "单位",
						width: "15%"
					}, {
						width: "10%",
						field: "quantity",
						title: "数量",
						events: {
							'blur .quantity': function(e, value, row, index) {
								if(isNaN($(this).val())) {
									layer.msg("请输入数字");
									$(this).val(value);
									return;
								} else if($(this).val() < 1) {
									layer.msg("数量不小于1");
									$(this).val(value);
									return;
								} else if($(this).val().indexOf('.') != '-1') {
									layer.msg("请输入整数");
									$(this).val(value);
									return;
								}
								row.quantity = $(this).val()
							},
							'click .quantity': function(e, value, row, index) {
								e.stopPropagation()
							}
						},
						formatter: function(value, row) {
							return '<input class="quantity" value="' + 1 + '">';
						}
					}, {
						field: "op",
						title: "操作",
						width: "25%",
						events: {
							'click .add': function(e, value, row, index) {
								row.goods_info.forEach(v => {
									for(let i = 0; i < _this.packageDetail_table.length; i++) {
										if(_this.packageDetail_table[i].merchant_goods_id == v.id) {
											return false;
										}
									}
									_this.packageDetail_table.push({ merchant_goods_id: v.id, quantity: row.quantity || 1, goods_name: v.goods_name, goods_type_name: v.goods_type_name, goods_unit_name: v.goods_unit_name,cost_price: v.cost_price, goods_img: v.good_img ,allprice:v.cost_price});
								})
								layer.msg("成功添加商品");
								_this.initDetailTable();
							}
						},
						formatter: function(value, row, index) {
							return '<span class="text-blue add">添加</span>';
						}
					}]
				})
			},
			getGoodsPackage: function(params, _this) {
				let pageNumber = 1;
				if(params.data.offset != 0) {
					pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
				}
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"shop_id": $(_this.$refs.package_name_shop).val(),
							"goods_type": _this.goodsType_sign_id,
							"goods_name": _this.searchGoodsName,
							"recommend": "",
							"is_sell": "1",
							"page": pageNumber,
							"page_size": 5,
							"status": '1'
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "merchantGoods/searchMerchantGoodsPackage",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: {
						json: datas2
					},
					success: function(data) {
						if(data.response.result_code == "true") {
							params.success({
								total: data.response.result.data.total,
								rows: data.response.result.data.rows
							});
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data.response.error_msg);
							params.success({
								total: 0,
								rows: []
							});
						}
					},
					error: function(err) {
						layer.msg("网络错误");
					}
				});
			},

			// 初始化商品类型
			getCusPakage() {
				const _this = this;

				_this.goodsType_list = [{
					id: "0",
					text: "全部"
				}, {
					id: "-2",
					text: "商品套餐",
					sign: '-2',
					sign_id: '0'
				}];
				Vue.axios.post('PublicData/api_getWaresType', {
					"header": Vue.request_header,
					"request": {
						"param": {}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						res.data.response.result.data.forEach(v => {
							_this.goodsType_list.push({
								id: '-2' + v.id,
								text: v.name,
								sign: '-2',
								sign_id: v.id
							});
						});
						_this.initGoodsType();
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg('出错啦');
				});
			},
			initGoodsType: function() {
				let _this = this;

				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "PublicData/api_getGoodsType",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: {
						json: datas2
					},
					success: function(data) {
						if(data.response.result_code == "true") {
							$.each(data.response.result.data, function(k, v) {
								_this.goodsType_list.push({ id: v.id, text: v.name });
							});
							$(_this.$refs.addGoods_select).select2({
								data: _this.goodsType_list,
								width: '100%'
							}).on("select2:select", function(e) {
								_this.goodsType_sign = e.params.data.sign;
								if(_this.goodsType_sign == '-2') {
									_this.goodsType_sign_id = e.params.data.sign_id;
									_this.initGoodsPackage();
								} else {
									_this.initGoodsTable();
								}
							});
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
	/*.packageName {
		padding: 50px 60px;
	}*/
	/*陈婷页面公用样式*/
	.ct-topTitle {
		color: #4f4f4f;
		font-size: 18px;
		height: 40px;
		line-height: 40px;
	}
	
	.ct-row {
		margin: 40px 0;
	}
	
	.ct-label {
		float: left;
		color: #5e5e5e;
		height: 32px;
		line-height: 32px;
		font-size: 14px;
		font-weight: normal;
		margin-bottom: 0px;
	}
	
	.ct-upload {
		height:240px;
		width: 660px;
		margin: 0 auto;
		.uploadimg {
			width: 660px;
			height:240px;
			margin: 0;
		}
		.defaultimage {
			background: url(../../assets/images/upload2.png) no-repeat center;
		}
	}
	
	.scroll-table {
		overflow: hidden;
	}
	
	.uploadinput {
		display: none;
	}
	
	.orange-text>a {
		color: #009af0!important;
		margin: 0 10px;
	}
	
	.handle-package {
		width: 836px;
		margin: 20px auto;
	}
	
	.handle-package .row {
		width: 100%;
		margin: 30px 0px;
	}

	#editGoods_popup {
		display: none;
		.editGood-content {
			width: 610px;
			margin: 20px auto;
			border-bottom: 1px solid #e4e4e4;
			li {
				width: 100%;
				height: 50px;
				line-height: 50px;
				color: #5e5e5e;
				font-size: 14px;
				&.editGood-content-title {
					font-size: 16px;
					background-color: #f5f5f5;
				}
				span,
				input {
					display: inline-block;
					width: 25%;
					text-align: center;
				}
			}
		}
		.editGood-btn {
			width: 370px;
			margin: 0 auto;
			button {
				float: left;
				margin-top: 30px;
			}
		}
	}

	#chooseType_popup {
		display: none;
		.chooseType-content {
			width: 100%;
			padding-left: 100px;
			margin: 20px auto;
			li {
				width: 100%;
				color: #5e5e5e;
				font-size: 14px;
				margin-bottom: 10px;
				.choosetype-txt {
					width: 220px;
					display: inline-block;
					p {
						line-height: 24px;
						color: #606060;
						font-size: 14px;
						margin: 0;
						&.orange-text {
							color: #009af0;
							font-size: 12px;
							line-height: 16px;
							height: auto!important;
						}
					}
				}
				input {
					float: left;
					margin-right: 10px;
				}
			}
		}
		.chooseType-btn {
			width: 370px;
			margin: 0 auto;
			button {
				float: left;
				margin-top: 30px;
			}
		}
	}

	#addGoods_popup {
		display: none;
		padding: 20px 60px;
		.row {
			margin-bottom: 20px;
		}
	}
	.good-num-pop {
		display: none;
		width: 70%;
		margin: 20px auto;
		label {
			padding: 0;
			line-height: 32px;
			color: #5e5e5e;
			font-size: 14px;
			text-align: right;
			font-weight: normal;
		}
		.row {
			margin: 0 0 20px;
			span {
				line-height: 32px;
				font-size: 14px;
			}
		}
	}

	.package-name-bottom {
		display: block;
		margin: 40px auto;
		width: 360px;
	}

	.packageNameDetail {
		.ChooseType {
			cursor: pointer;
		}
		.my-el-hint {
			position: absolute;
			top: -5px;
		}
	}

	.ct-imgwrap {
		img {
			width: 100px;
			height: 60px;
			background: url(../../assets/images/upload.png) center no-repeat;
		}
	}
	.ct-imgwrap1 {
		img {
			width: 70px;
			height: 70px;
			background: url(../../assets/images/upload.png) center no-repeat;
		}
	}
	.turnRed{
		color:#ff4141!important ;
	}
</style>